(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aaa-custom-section-birthdate_culc"] && !Shopify.designMode) return;
  try {
    
  
  
  
  	$(function(){
  
  		var birthNumberList = [
  		'',
  		'<a href="https://atozstore.love/pages/numerology01"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/1_480x480.webp?v=1706249109"></a>',
  		'<a href="https://atozstore.love/pages/numerology02"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/2_2f6b8b97-eb1c-4b8d-8beb-ebfe535aa02c_480x480.webp?v=1706249264"></a>',
  		'<a href="https://atozstore.love/pages/numerology03"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/3_40f32ddf-499e-479c-a983-babf99d7c08e_480x480.webp?v=1706249301"></a>',
  		'<a href="https://atozstore.love/pages/numerology04"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/4_b89093ac-8067-4114-9f46-ceb2c68501bb_480x480.webp?v=1706249319"></a>',
  		'<a href="https://atozstore.love/pages/numerology05"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/5_7dbe4b49-2def-4c52-afd1-e449824bdfd4_480x480.webp?v=1706249335"></a>',
  		'<a href="https://atozstore.love/pages/numerology06"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/efe02c23c1ae22d6d37cbb576831daff_25bdce4f-4f3d-458d-be46-237f92d89e25_480x480.webp?v=1706249351"></a>',
  		'<a href="https://atozstore.love/pages/numerology07"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/6c49fff4c3ced4eadb8e7a0c6817d0ff_ab124add-a558-4db3-b8ab-9bd2b6eed9db_480x480.webp?v=1706249367"></a>',
  		'<a href="https://atozstore.love/pages/numerology08"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/8_7f95c2fb-b407-4433-ad02-ac3cbee4d29b_480x480.webp?v=1706249386"></a>',
  		'<a href="https://atozstore.love/pages/numerology09"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/9_724a9ac4-9679-4a3b-8999-44f314e58ab1_480x480.webp?v=1706249400"></a>',
  		'',
  		'<a href="https://atozstore.love/pages/numerology11"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/11_1d0fc842-c51f-4f06-b0a7-86d4aaef98f5_480x480.webp?v=1706249414"></a>',
  		'','','','','','','','','','',
  		'<a href="https://atozstore.love/pages/numerology22"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/22_3df13e9a-38c8-49c7-b93a-10d13953560f_480x480.webp?v=1706249431"></a>',
  		'','','','','','','','','','',
  		'<a href="https://atozstore.love/pages/numerology33"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/33_9cb64559-407b-4345-8cba-51fed3e6c27c_480x480.webp?v=1706249446"></a>'
  		];
  
  
  		function addDigits(num) {
  			return num.toString().split('').reduce(function(acc, digit) {
  				return acc + parseInt(digit, 10);
  			}, 0);
  		}
  
  		function processNumber(area, number) {
  			if ([11, 22, 33].includes(number)) {
  				$(area).find('.result_link').html(birthNumberList[number]);
  			} else {
  				while (number > 9) {
  					number = addDigits(number.toString());
  					if([11, 22, 33].includes(number)) break;
  				}
  				$(area).find('.result_link').html(birthNumberList[number]);
  			}
  		}
  
  		function calculateBtn() {
  			var year = document.getElementById('year').value;
  			var month = document.getElementById('month').value;
  			var day = document.getElementById('day').value;
  
  			var prevArea = $('#p_result');
  			var nowArea = $('#n_result');
  			var afterArea = $('#a_result');
  
  			if ([11, 22, 33].includes(parseInt(day))) {
  				var prevPtn = parseInt(day);
  			} else {
  				var prevPtn = addDigits(day);
  			}
  
  			var nowPtn = addDigits(year) + addDigits(month) + addDigits(day);
  			var afterPtn = addDigits(month) + addDigits(day);
  
  			processNumber(prevArea,prevPtn);
  			processNumber(nowArea,nowPtn);
  			processNumber(afterArea,afterPtn);
  
  		}
  
  		$('#calc_btn').on('click',function(){
  			if($('.birthdate_culc_result').css('display') === 'block'){
  				$('.birthdate_culc_result').css('display','none');
  			}
  			calculateBtn();
  			$('.birthdate_culc_result').slideDown();
  		});
  	});
  
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aaa-custom-section-numelogy-result"] && !Shopify.designMode) return;
  try {
    
  
  $(function(){
  		const birthNumberImgList = [
  				'',
  				'<img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/1_480x480.webp?v=1706249109">',
  				'<img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/2_2f6b8b97-eb1c-4b8d-8beb-ebfe535aa02c_480x480.webp?v=1706249264">',
  				'<img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/3_40f32ddf-499e-479c-a983-babf99d7c08e_480x480.webp?v=1706249301">',
  				'<img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/4_b89093ac-8067-4114-9f46-ceb2c68501bb_480x480.webp?v=1706249319">',
  				'<img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/5_7dbe4b49-2def-4c52-afd1-e449824bdfd4_480x480.webp?v=1706249335">',
  				'<img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/efe02c23c1ae22d6d37cbb576831daff_25bdce4f-4f3d-458d-be46-237f92d89e25_480x480.webp?v=1706249351">',
  				'<img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/6c49fff4c3ced4eadb8e7a0c6817d0ff_ab124add-a558-4db3-b8ab-9bd2b6eed9db_480x480.webp?v=1706249367">',
  				'<img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/8_7f95c2fb-b407-4433-ad02-ac3cbee4d29b_480x480.webp?v=1706249386">',
  				'<img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/9_724a9ac4-9679-4a3b-8999-44f314e58ab1_480x480.webp?v=1706249400">',
  				'',
  				'<img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/11_1d0fc842-c51f-4f06-b0a7-86d4aaef98f5_480x480.webp?v=1706249414">',
  				'','','','','','','','','','',
  				'<img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/22_3df13e9a-38c8-49c7-b93a-10d13953560f_480x480.webp?v=1706249431">',
  				'','','','','','','','','','',
  				'<img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/33_9cb64559-407b-4345-8cba-51fed3e6c27c_480x480.webp?v=1706249446">'
  		];
  
  		const pageNumber_URL = {
  				numerology01: '1',
  				numerology02: '2',
  				numerology03: '3',
  				numerology04: '4',
  				numerology05: '5',
  				numerology06: '6',
  				numerology07: '7',
  				numerology08: '8',
  				numerology09: '9',
  				numerology11: '11',
  				numerology22: '22',
  				numerology33: '33'
  		};
  
  		// 半角数字を全角数字に変換する関数
  		function toFullWidth(str) {
  				return str.replace(/[0-9]/g, function(s) {
  						return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
  				});
  		}
  
  		let urlFileName = location.pathname.split('/').pop();
  
  		// ファイル名から拡張子を除去（必要な場合）
  		let fileNameWithoutExtension = urlFileName.split('.')[0];
  
  		// pageNumber_URLから対応する数字を取得
  		let pageNumber = pageNumber_URL[fileNameWithoutExtension];
  
  		if (pageNumber) {
  				// 数字を全角に変換
  				let fullWidthNumber = toFullWidth(pageNumber);
  				$('.section-numelogy-result .contents .contents-heading').text('数秘' + fullWidthNumber + 'のあなた');
  				$('.section-numelogy-result .kv img').replaceWith(birthNumberImgList[parseInt(pageNumber)]);
  		} else {
  				console.error('Invalid page number');
  		}
  
  		//https://twitter.com/intent/tweet?url=https://atozstore.love/pages/numerology01&text=
  });
  
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aaa-section-numerology-link"] && !Shopify.designMode) return;
  try {
    
  
  
  
  	$(function(){
  
  		var birthNumberList = [
  		'',
  		'<a href="https://atozstore.love/pages/numerology01"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/1_480x480.webp?v=1706249109"></a>',
  		'<a href="https://atozstore.love/pages/numerology02"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/2_2f6b8b97-eb1c-4b8d-8beb-ebfe535aa02c_480x480.webp?v=1706249264"></a>',
  		'<a href="https://atozstore.love/pages/numerology03"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/3_40f32ddf-499e-479c-a983-babf99d7c08e_480x480.webp?v=1706249301"></a>',
  		'<a href="https://atozstore.love/pages/numerology04"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/4_b89093ac-8067-4114-9f46-ceb2c68501bb_480x480.webp?v=1706249319"></a>',
  		'<a href="https://atozstore.love/pages/numerology05"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/5_7dbe4b49-2def-4c52-afd1-e449824bdfd4_480x480.webp?v=1706249335"></a>',
  		'<a href="https://atozstore.love/pages/numerology06"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/efe02c23c1ae22d6d37cbb576831daff_25bdce4f-4f3d-458d-be46-237f92d89e25_480x480.webp?v=1706249351"></a>',
  		'<a href="https://atozstore.love/pages/numerology07"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/6c49fff4c3ced4eadb8e7a0c6817d0ff_ab124add-a558-4db3-b8ab-9bd2b6eed9db_480x480.webp?v=1706249367"></a>',
  		'<a href="https://atozstore.love/pages/numerology08"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/8_7f95c2fb-b407-4433-ad02-ac3cbee4d29b_480x480.webp?v=1706249386"></a>',
  		'<a href="https://atozstore.love/pages/numerology09"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/9_724a9ac4-9679-4a3b-8999-44f314e58ab1_480x480.webp?v=1706249400"></a>',
  		'',
  		'<a href="https://atozstore.love/pages/numerology11"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/11_1d0fc842-c51f-4f06-b0a7-86d4aaef98f5_480x480.webp?v=1706249414"></a>',
  		'','','','','','','','','','',
  		'<a href="https://atozstore.love/pages/numerology22"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/22_3df13e9a-38c8-49c7-b93a-10d13953560f_480x480.webp?v=1706249431"></a>',
  		'','','','','','','','','','',
  		'<a href="https://atozstore.love/pages/numerology33"><img src="https://cdn.shopify.com/s/files/1/0633/9647/9198/files/33_9cb64559-407b-4345-8cba-51fed3e6c27c_480x480.webp?v=1706249446"></a>'
  		];
  
  
  	});
  
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
